import styles from "../detalheEsocial.styles.module.css";
import {
  LARGURA_REGUA,
  classeDoMes,
  marcosDaRegua,
  mesesDaEscala,
  textoVigencia,
} from "../utils/vigenciaRubrica.util";

const ALTURA_LINHA = 15;
const ALTURA_MARCO = 14;

function Rotulos({ marcos, simbolo, acima }) {
  const lado = acima ? "bottom" : "top";
  return marcos.map((e) => (
    <span key={`${e.indice}|${e.texto}`}>
      <i className={`${styles.reguaMarco} ${styles[`marco_${e.tipo}`]}`} style={{ left: e.centro - 4, [lado]: 0 }} aria-hidden="true">
        {simbolo}
      </i>
      {e.linha > 0 ? (
        <i
          className={styles.reguaTraco}
          style={{ left: e.centro, [lado]: ALTURA_MARCO, height: e.linha * ALTURA_LINHA }}
          aria-hidden="true"
        />
      ) : null}
      <b
        className={`${styles.reguaRotulo} ${styles[`marco_${e.tipo}`]}`}
        style={{ left: e.esquerda, width: e.largura, [lado]: ALTURA_MARCO + e.linha * ALTURA_LINHA }}
      >
        {e.texto}
      </b>
    </span>
  ));
}

const alturaFaixa = (linhas) => (linhas ? ALTURA_MARCO + linhas * ALTURA_LINHA : 0);

function classeMes(classe) {
  if (classe === "aberta") return styles.mesAberto;
  if (classe === "fechada") return styles.mesFechado;
  return undefined;
}

/**
 * TXM-671 — célula "Período de vigência" (opção L): régua com um quadrado por mês da escala
 * (verde = coberto por vigência em aberto, azul = só encerrada), ▾ + MM/AA do início em cima e
 * ▴ + MM/AA do fim (ou "atual") embaixo. Todas as vigências ficam visíveis, sem clique; o
 * texto `MM/AAAA → MM/AAAA` vai no tooltip e no rótulo de acessibilidade.
 *
 * @param {{ vigencias: Array<{inicio: string, fim: string|null}>, escala: {inicio: string, fim: string}|null }} props
 */
export default function CelulaVigencia({ vigencias, escala }) {
  if (!vigencias || vigencias.length === 0) {
    return (
      <td className={styles.vigenciaCell} title="Sem vigência registrada">
        —
      </td>
    );
  }
  const texto = vigencias.map(textoVigencia).join("; ");
  const meses = mesesDaEscala(escala);
  if (meses.length === 0) {
    return <td className={styles.vigenciaCell}>{texto}</td>;
  }
  const marcos = marcosDaRegua(vigencias, escala);
  return (
    <td className={styles.vigenciaCell} title={texto}>
      <div className={styles.regua} role="img" aria-label={texto} style={{ width: LARGURA_REGUA }}>
        <div className={styles.reguaFaixa} style={{ height: alturaFaixa(marcos.linhasAcima) }}>
          <Rotulos marcos={marcos.inicios} simbolo="▾" acima />
        </div>
        <div className={styles.reguaMeses} style={{ gridTemplateColumns: `repeat(${meses.length}, 1fr)` }}>
          {meses.map((m) => (
            <span key={m} className={classeMes(classeDoMes(m, vigencias))} />
          ))}
        </div>
        <div className={styles.reguaFaixa} style={{ height: alturaFaixa(marcos.linhasAbaixo) }}>
          <Rotulos marcos={marcos.fins} simbolo="▴" acima={false} />
        </div>
      </div>
    </td>
  );
}
